export enum EmailSubjectType {
    ConvoName = 'email_subject_convo_name',
    NewChat = 'email_subject_new_chat',
    ReminderConvoName = 'reminder_email_subject_convo_name',
    ReminderChannelName = 'reminder_email_subject_channel_name',
    Custom = 'custom_subject_line',
}
